import { MatIconModule } from '@angular/material/icon';
import { TableComponent } from './table.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from "@angular/material/sort";
import { PaginatorComponent } from './components/paginator/paginator.component';
import { MatDialogModule } from "@angular/material/dialog";
import { ConfirmDialogModule } from "@/shared/components/confirm-dialog/confirm-dialog.module";
import { FilterComponent } from './components/filter/filter.component';
import { SearchbarComponent } from './components/searchbar/searchbar.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { CheckboxFilterComponent } from './components/checkbox-filter/checkbox-filter.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [
    TableComponent,
    PaginatorComponent,
    FilterComponent,
    SearchbarComponent,
    CheckboxFilterComponent,
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDialogModule,
    ConfirmDialogModule,
    MatCheckboxModule,
    MatIconModule,
    MatMenuModule,
  ],
  exports: [TableComponent],
})
export class TableModule { }
